"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateDeliveryChannelEvent = exports.Name = void 0;
const Name = exports.Name = 'update-delivery-channel';
const UpdateDeliveryChannelEvent = exports.UpdateDeliveryChannelEvent = Name;
//# sourceMappingURL=index.js.map